import { render, staticRenderFns } from "./draggableComponente.vue?vue&type=template&id=4294bb41&scoped=true&"
import script from "./draggableComponente.vue?vue&type=script&lang=js&"
export * from "./draggableComponente.vue?vue&type=script&lang=js&"
import style0 from "./draggableComponente.vue?vue&type=style&index=0&id=4294bb41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4294bb41",
  null
  
)

export default component.exports